import { render, staticRenderFns } from "./DigitalWorkshop.vue?vue&type=template&id=3dcf3b25"
import script from "./DigitalWorkshop.vue?vue&type=script&lang=js"
export * from "./DigitalWorkshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports